var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('file-upload',{staticClass:"mr-1",attrs:{"name":"resume"},on:{"loaded":_vm.setAttachments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }